import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

import useAccountSettingsLinks from '@/layouts/SettingsLayout/hooks/useAccountSettingsLinks'
import SettingsLayout from '@/layouts/SettingsLayout/SettingsLayout'
import { type Icon } from '@tabler/icons-react'

export const Route = createFileRoute('/$workspaceName/$environment/account-settings')({
  component: SettingsLayoutRoute,
})

export type SettingsLink = {
  label: string
  href: string
  icon: Icon
  active?: boolean
}

function SettingsLayoutRoute() {
  const location = useLocation()
  const { links } = useAccountSettingsLinks({ pathname: location.pathname })

  return (
    <SettingsLayout key={location.pathname} title={'Account Settings'} links={links}>
      <Outlet />
    </SettingsLayout>
  )
}
